import invariant from 'tiny-invariant'

import useAppSelector from '@/hooks/useAppSelector'
import { selectCurrentCompanyUser } from '@/redux/slices/session'

function useCurrentCompanyUserOrFail() {
  const currentCompanyUser = useAppSelector(selectCurrentCompanyUser)

  invariant(
    currentCompanyUser,
    'Used useCurrentCompanyUser in a place where user is not authenticated',
  )

  return currentCompanyUser
}

export default useCurrentCompanyUserOrFail
